
import React, { useState, useEffect } from 'react';
import { navigate } from 'hookrouter';
import { useDispatch, useSelector } from 'react-redux';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { colors, Text } from 'react-elemental';
import Image from 'react-bootstrap/Image';
import { Link, useLocation } from 'react-router-dom';
import { FaBars as Bars } from 'react-icons/fa';
import { IoMdCloseCircle as Close } from 'react-icons/io';
import { logout } from '../../../actions';
import logo from '../../../commons/assets/helix.svg';
import './styles.scss';
import { config } from '../../../config';

// Cierra el menú responsive de Bootstrap simulando el clic en el botón de toggle
const closeBootstrapMenu = () => {
  const toggler = document.querySelector('.navbar-toggler');
  const nav = document.getElementById('responsive-navbar-nav');
  if (nav && nav.classList.contains('show') && toggler) {
    toggler.click();
  }
};

const Menu = ({
  handleLogout,
  location,
  isMobile,
}) => {
  const getClassLink = (path) => {
    if (location === path) return `${isMobile ? 'mr-3' : ''}  active`;
    return `${isMobile ? 'mr-3' : ''}`;
  };

  return (
    <>
      <Link
        to="/app/config"
        className={ getClassLink('/app/config') }
      >
        <Text color={ colors.primary }>Configuración</Text>
      </Link>

      <Link
        to="/app/products"
        className={ getClassLink('/app/products') }
      >
        <Text color={ colors.primary }>Productos</Text>
      </Link>

      <Link
        to="/app/planning"
        className={ getClassLink('/app/planning') }
      >
        <Text color={ colors.primary }>Planificación</Text>
      </Link>

      <Link
        to="/app/bookings"
        className={ getClassLink('/app/bookings') }
      >
        <Text color={ colors.primary }>Gestionar reservas</Text>
      </Link>

      {/* Anchor to landing FAQ section when user is in admin routes */}
      <a
        href="#faq"
        data-target="#faq"
        className={ getClassLink('#faq') }
      >
        <Text color={ colors.primary }>Preguntas frecuentes</Text>
      </a>

      <Link
        to="/"
        className={ getClassLink('/') }
      >
        <Text color={ colors.primary }>Inicio</Text>
      </Link>

      <Link
        to="/app"
        className={ getClassLink('/app') }
      >
        <Text color={ colors.primary }>Reservar</Text>
      </Link>

      <Link
        to="/dashboard/news"
        className={ getClassLink('/app') }
      >
        <Text color={ colors.primary }>Dashboard</Text>
      </Link>

      <Link
        to=""
        onClick={ () => handleLogout() }
      >
        <Text color={ colors.primary }>Cerrar sesión</Text>
      </Link>
    </>
  );
};

const CustomNavBar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const dispatch = useDispatch();
  const lc = useLocation();
  const location = lc.pathname;

  const state = useSelector((s) => ({ auth: s.auth }));

  const handleLogout = () => {
    dispatch(logout());
    navigate('/');
  };

  // Smooth scroll / cross-route anchors for landing sections
  useEffect(() => {
    const containers = Array.from(document.querySelectorAll('[data-landing-shortcuts]'));
    if (!containers.length) return;
    const onClick = (e) => {
      const anchor = e.target.closest('a[data-target]');
      if (!anchor) return;
      let target = anchor.getAttribute('data-target');
      if (!target) return;
      if (!target.startsWith('#')) return;
      if (location !== '/') {
        // Guardamos el target pero navegamos sin hash para que la landing siempre inicie en top
        try { sessionStorage.setItem('landingScrollTarget', target); } catch (err) {}
        e.preventDefault();
        window.location.href = '/';
        return;
      }
      const el = document.querySelector(target);
      if (!el) return;
      e.preventDefault();
      const nav = document.querySelector('.navbar');
      const baseOffset = (nav ? nav.getBoundingClientRect().height : 0) + 28;
      let topNode = el;
      // Tomamos heading para oil-products y faq
      if (['#oil-products','#faq','#promotions'].includes(target)) {
        const heading = el.querySelector('h1,h2,h3,h4');
        if (heading) topNode = heading;
      }
      // Offset uniforme (puede ajustarse si pides cambios):
  const extraOffset = (target === '#oil-products') ? 40 : (target === '#faq' ? 60 : (target === '#promotions' ? 60 : 0));
      let top = topNode.getBoundingClientRect().top + window.scrollY - (baseOffset + extraOffset);
      if (top < 0) top = 0;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      if (top > maxScroll) top = maxScroll;
      window.scrollTo({ top, behavior: 'smooth' });
      // Ajuste tardío ligero si el layout se mueve
      setTimeout(() => {
        const adj = topNode.getBoundingClientRect().top + window.scrollY - (baseOffset + extraOffset);
        if (Math.abs(adj - window.scrollY) > 6) {
          let bounded = adj;
          if (bounded < 0) bounded = 0;
          if (bounded > maxScroll) bounded = maxScroll;
          window.scrollTo({ top: bounded, behavior: 'smooth' });
        }
      }, 250);
  // Eliminado replaceState para no afectar el historial
    };
    containers.forEach(c => c.addEventListener('click', onClick));
    return () => containers.forEach(c => c.removeEventListener('click', onClick));
  }, [location]);
  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      className="container mb-3 mt-3"
    >
      <Navbar.Brand>
        <Link to="/" onClick={(e) => {
          if (location === '/') {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
            // Eliminado replaceState para no afectar el historial
          } else {
            try { sessionStorage.setItem('landingScrollTarget', '#__top'); } catch (err) {}
          }
        }}>
          <Image
            className="d-none d-lg-block"
            alt="Shell"
            src={ logo }
            color={ colors.primary }
            width="auto"
            height="50px"
          />

          <Image
            className="d-lg-none d-xl-none margin-top--10"
            alt="Shell"
            src={ logo }
            color={ colors.primary }
            width="auto"
            height="38px"
          />
        </Link>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="mr-auto" />

        <Nav className="d-none d-lg-block">
          {
            state.auth.isLogged ? (
              <div className="d-inline-flex align-items-center">
                <Text
                  bold
                  className="text-capitalize font-weight-bolder text-danger mr-3 mt-3 mb-0 pb-3"
                >
                  { state.auth.currentUser.username }
                </Text>
                <span
                  className="btn-menu-header rounded-circle d-flex justify-content-center align-items-center"
                  onClick={ () => setShowMenu(!showMenu) }
                >
                  <Bars />
                </span>
                { showMenu && (
                  <div
                    className="panel-menu-header"
                    data-landing-shortcuts
                    onClick={ () => setShowMenu(false) }
                  >
                    <div
                      className="close-icon"
                      onClick={ () => setShowMenu(!showMenu) }
                    >
                      <Close />
                    </div>
                    <span>
                      <span
                        className="text-capitalize font-weight-bold text-white pl-1"
                      >
                        Hola &nbsp;{ state.auth.currentUser.username }
                      </span>
                      <Menu
                        handleLogout={ handleLogout }
                        location={ location }
                      />
                    </span>
                  </div>
                ) }
              </div>
            ) : (
              <div className="d-inline-flex align-items-start menu-title admin-links-wrapper">
                <div className="d-flex flex-column justify-content-start pr-3 admin-label-position">
                  <span className="text-muted shell-bold admin-label-text">&nbsp;</span>
                </div>
                <div className="d-flex align-items-center flex-wrap admin-links-group" data-landing-shortcuts>
                  <a href="#features" data-target="#features" className="mr-3 nav-inline-link admin-inline"><Text className="shell-bold text-muted admin-link-text" color={ colors.primary }>Servicios</Text></a>
                  <a href="#steps" data-target="#steps" className="mr-3 nav-inline-link admin-inline"><Text className="shell-bold text-muted admin-link-text" color={ colors.primary }>¿Cómo agendar?</Text></a>
                  <a href="#oil-products" data-target="#oil-products" className="mr-3 nav-inline-link admin-inline"><Text className="shell-bold text-muted admin-link-text" color={ colors.primary }>Productos</Text></a>
                  {config.ENABLE_PROMOTIONS && <a href="#promotions" data-target="#promotions" className="mr-3 nav-inline-link admin-inline"><Text className="shell-bold text-muted admin-link-text" color={ colors.primary }>Promociones</Text></a>}
                  <a href="#faq" data-target="#faq" className="mr-3 nav-inline-link admin-inline"><Text className="shell-bold text-muted admin-link-text" color={ colors.primary }>Preguntas frecuentes</Text></a>
                  <Link to="/app/login" className="nav-inline-link admin-inline"><Text bold className="shell-bold admin-link-text" color={ colors.primary }>ADMIN</Text></Link>
                </div>
              </div>
            )
          }
        </Nav>

        <Nav className="d-block d-lg-none mt-3">
          {
            state.auth.isLogged
              ? (
                <span
                  id="link-container"
                  className="d-inline-flex"
                >
                  <Menu
                    handleLogout={ handleLogout }
                    location={ location }
                    isMobile
                  />

                  <Text
                    bold
                    size="iota"
                    className="text-capitalize mt-1"
                  >
                    { state.auth.currentUser.username }
                  </Text>
                </span>
              )
              : (
                <div className="text-center mt-3" data-landing-shortcuts>
                  <div className="d-flex flex-column quick-links-mobile">
                    <a href="#features" data-target="#features" className="py-1" onClick={() => { setShowMenu(false); closeBootstrapMenu(); }}><Text size="iota" className="shell-bold text-muted" color={ colors.primary }>Servicios</Text></a>
                    <a href="#steps" data-target="#steps" className="py-1" onClick={() => { setShowMenu(false); closeBootstrapMenu(); }}><Text size="iota" className="shell-bold text-muted" color={ colors.primary }>¿Cómo agendar?</Text></a>
                    <a href="#oil-products" data-target="#oil-products" className="py-1" onClick={() => { setShowMenu(false); closeBootstrapMenu(); }}><Text size="iota" className="shell-bold text-muted" color={ colors.primary }>Productos</Text></a>
                    {config.ENABLE_PROMOTIONS && <a href="#promotions" data-target="#promotions" className="py-1" onClick={() => { setShowMenu(false); closeBootstrapMenu(); }}><Text size="iota" className="shell-bold text-muted" color={ colors.primary }>Promociones</Text></a>}
                    <a href="#faq" data-target="#faq" className="py-1" onClick={() => { setShowMenu(false); closeBootstrapMenu(); }}><Text size="iota" className="shell-bold text-muted" color={ colors.primary }>Preguntas frecuentes</Text></a>
                    <Link to="/app/login" className="py-2"><Text size="iota" bold className="shell-bold" color={ colors.primary }>ADMIN</Text></Link>
                  </div>
                </div>
              )
          }
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default CustomNavBar;
